import * as React from 'react'
import { EyeNoneIcon, EyeOpenIcon } from '@radix-ui/react-icons'
import { clsx } from 'clsx'
import { Button } from '~/sotano-kit/primitives/button'
import { CopyTooltip } from '~/sotano-kit/primitives/copy-tooltip'
import { TerminalIcon } from '~/components/icons/terminal'
import { PageIcon } from '~/components/icons/page'

export const ExampleActions = ({
  snippetToCopy,
  snippetToCopyLabel,
  showSecret,
  onShowSecret,
  label,
  icon,
  className,
  children,
}: {
  snippetToCopy: string | (() => string | Promise<string>)
  snippetToCopyLabel?: React.ReactNode
  showSecret?: boolean
  onShowSecret?: () => void
  label: React.ReactNode
  icon?: React.ReactNode
  className?: string
  children?: React.ReactNode
}) => {
  return (
    <div
      className={clsx(
        'flex items-center justify-between border-b border-dark-border-solid py-2 px-4 text-dark-faint h-10 bg-dark-base light:bg-dark-shade light:text-dark-bright',
        className
      )}
    >
      {icon ?? (label === 'Terminal' ? <TerminalIcon /> : <PageIcon />)}
      <p className="ml-[5px] mr-auto text-xs leading-4">{label}</p>
      <div className="flex items-center gap-x-2">
        {children}
        {onShowSecret && (
          <Button
            unstyled
            focusStyled
            onClick={onShowSecret}
            aria-label="show secret"
            className="text-[13px] transition-colors duration-200 hover:text-light-faint"
          >
            {!showSecret ? (
              <span className="inline-flex items-center gap-2">
                <EyeOpenIcon className="h-4 w-4" /> Show secret
              </span>
            ) : (
              <span className="inline-flex w-[100px] items-center gap-2">
                <EyeNoneIcon className="h-4 w-4" /> Hide secret
              </span>
            )}
          </Button>
        )}
        <CopyTooltip label={snippetToCopyLabel} copyContent={snippetToCopy} />
      </div>
    </div>
  )
}

export const CodeSnippetContainer = ({
  children,
  className,
}: {
  children?: React.ReactNode
  className?: string
}) => {
  return (
    <div
      className={clsx(
        'w-full rounded-lg border border-dark-border-solid bg-dark-bg overflow-hidden',
        className
      )}
    >
      {children}
    </div>
  )
}
